import { BaseApiClient } from "../base-api-client";
export class CryptoAlertsClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/crypto-alerts`,
        };
        super(fullConfig, "CryptoAlertsClient");
    }
    async getRecentListings(userId, options) {
        try {
            const queryParams = new URLSearchParams();
            if (options?.limit) {
                queryParams.append("limit", String(options.limit));
            }
            if (options?.page) {
                queryParams.append("page", String(options.page));
            }
            if (options?.tier) {
                queryParams.append("tier", String(options.tier));
            }
            const query = queryParams.toString();
            const response = await this.get(`/listings/${userId}${query ? `?${query}` : ""}`);
            if (!response.success) {
                throw new Error(response.error || "Failed to get recent listings");
            }
            return (response.data || {
                alerts: [],
                hasMore: false,
                page: options?.page ?? 1,
            });
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting recent listings:", this.truncateError(error));
            throw error;
        }
    }
    async getRecentDelistings(userId, options) {
        try {
            const queryParams = new URLSearchParams();
            if (options?.limit) {
                queryParams.append("limit", String(options.limit));
            }
            if (options?.page) {
                queryParams.append("page", String(options.page));
            }
            if (options?.tier) {
                queryParams.append("tier", String(options.tier));
            }
            const query = queryParams.toString();
            const response = await this.get(`/delistings/${userId}${query ? `?${query}` : ""}`);
            if (!response.success) {
                throw new Error(response.error || "Failed to get recent delistings");
            }
            return (response.data || {
                alerts: [],
                hasMore: false,
                page: options?.page ?? 1,
            });
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting recent delistings:", this.truncateError(error));
            throw error;
        }
    }
    async getAlertById(alertId) {
        try {
            const response = await this.get(`/${alertId}`);
            if (!response.success) {
                return null;
            }
            return response.data || null;
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting alert by ID:", this.truncateError(error));
            return null;
        }
    }
    async getLeaderboardAlerts() {
        try {
            const response = await this.get("/leaderboard");
            if (!response.success) {
                return { listings: [], delistings: [] };
            }
            return response.data ?? { listings: [], delistings: [] };
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting leaderboard alerts:", this.truncateError(error));
            return { listings: [], delistings: [] };
        }
    }
    async getIncomingListings() {
        try {
            const response = await this.get("/incoming-listings");
            if (!response.success) {
                return [];
            }
            return response.data ?? [];
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting incoming listings:", this.truncateError(error));
            return [];
        }
    }
    async getPreviousAlerts(userId, currency, alertId) {
        try {
            const queryParams = new URLSearchParams({
                userId,
                currency,
            });
            if (alertId) {
                queryParams.append("alertId", alertId);
            }
            const response = await this.get(`/previous-alerts?${queryParams.toString()}`);
            if (!response.success) {
                return [];
            }
            return response.data || [];
        }
        catch (error) {
            console.error("[CryptoAlertsClient] Error getting previous alerts:", this.truncateError(error));
            return [];
        }
    }
}
//# sourceMappingURL=crypto-alerts-client.js.map